// extracted by mini-css-extract-plugin
export default {"fullscreen":"govCo_fullscreen__ZuCPX","bgImage":"govCo_bgImage__gchIj"};